import { render, staticRenderFns } from "./PickupList.vue?vue&type=template&id=3a19c9e8"
import script from "./PickupList.vue?vue&type=script&lang=js"
export * from "./PickupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports